import { render, staticRenderFns } from "./role-user.vue?vue&type=template&id=03d17b4f&scoped=true"
import script from "./role-user.vue?vue&type=script&lang=js"
export * from "./role-user.vue?vue&type=script&lang=js"
import style0 from "./role-user.vue?vue&type=style&index=0&id=03d17b4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d17b4f",
  null
  
)

export default component.exports